'use client';

import React from 'react';
import styles from './ThreePicturesTitle.module.scss';
import { useAOS } from '../../../../lib/hooks/useAOS';

interface ThreePicturesTitleProps {
  mainImage: string;
  topTitle: string;
  bottomTitle: string;
  sideImageOne: string;
  sideImageTwo: string;
  imageOnLeft?: boolean;
  titleAbove?: boolean;
  theme?: 'dark' | 'light';
}

const ThreePicturesTitle: React.FC<ThreePicturesTitleProps> = ({
  mainImage,
  topTitle,
  bottomTitle,
  sideImageOne,
  sideImageTwo,
  imageOnLeft = true,
  titleAbove = true,
  theme = 'dark',
}) => {
  const isDark = theme === 'dark';
  useAOS();

  // TODO - change img with the NextJS Image component

  return (
    <section className={`${styles.wrapper} ${isDark ? styles.dark : styles.light}`}>
      <div className={`${styles.inner} ${imageOnLeft ? '' : styles.reverse}`}>
        <div
          data-aos="fade-up"
          className={`${styles.mainImageWrapper} ${
            imageOnLeft ? styles.tightRight : styles.tightLeft
          }`}
        >
          <img
            src={mainImage}
            alt="Main"
            className={styles.mainImage}
            loading="lazy"
            data-aos="fade-up"
            data-aos-position="top-bottom"
          />
        </div>
        <div className={styles.rightContent}>
          {titleAbove && (
            <div className={styles.titleBlock} data-aos="zoom-in">
              <h2 className={styles.topTitle} data-aos="fade">
                {topTitle}
              </h2>
              <h2 className={styles.bottomTitle} data-aos="fade-up" data-aos-delay="100">
                {bottomTitle}
              </h2>
            </div>
          )}
          <div className={styles.sideImages}>
            <img
              src={sideImageOne}
              alt="Side one"
              className={styles.sideImage}
              loading="lazy"
              data-aos="fade-down"
            />
            <img
              src={sideImageTwo}
              alt="Side two"
              className={styles.sideImage}
              loading="lazy"
              data-aos="fade-up"
            />
          </div>
          {!titleAbove && (
            <div className={styles.titleBlock}>
              <h2 className={styles.topTitle}>{topTitle}</h2>
              <h2 className={styles.bottomTitle}>{bottomTitle}</h2>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ThreePicturesTitle;
